import { Children, type ReactNode } from 'react';
import { Box, Stack, Text } from '@mantine/core';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';

type Props = {
  children: ReactNode;
};

export function SuggestedActions({ children }: Props) {
  return (
    <Box>
      <Text size="textXs" fw={FONT_WEIGHTS.semibold} c="gray.10">
        Suggested actions ({Children.count(children)})
      </Text>
      <Stack mt="xs" gap="xxxs">
        {children}
      </Stack>
    </Box>
  );
}
